const LogOut = () => {
    return (
        <div></div>
    );
};

export default LogOut;